import React, { useEffect, useState } from 'react'
import {
	GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faUser, faPhone, faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons'

import ProfileSteps from '../components/ProfileSteps'
import TechTalentProfileSteps from '../components/TechTalent/ProfileSteps'
import VerifyMobile from '../components/VerifyMobile'
import MPSDemoModal from '../components/MPSDemoModal'
import { getEventFromRedirect } from '../helpers/url'

interface myProps {
	locale: string
}

const Register: React.FC = (props: myProps) => {
	const getIsMobileVerified = (): boolean => {
		if (typeof window !== 'undefined') {
			const token: string = window.localStorage.getItem('token') as string
			return token !== null
		} else {
			return false
		}
	}

	const [isMobileVerified, setIsMobileVerified] = useState<boolean>(false)
	
	const router = useRouter()
	const isNewProfile = true
	const isRedirectedFromMPS = typeof router.query.source !== 'undefined' && router.query.source === 'MPS'
	const token = router.query.token

	const isTechTalentEvent = getEventFromRedirect(router) === '104'

	useEffect(()=>{
		setIsMobileVerified(getIsMobileVerified())
	},[])
	// return isMobileVerified === true ? <ProfileSteps isNewProfile={isNewProfile} /> : (
	// <GoogleReCaptchaProvider
	// 	language="es-AR"
	// 	reCaptchaKey="6LcegMEfAAAAAOJZagpob5W_y7SBkbcI0Auhk3nu"
	// >
	// 	<VerifyMobile setIsMobileVerified={setIsMobileVerified} />
	// </GoogleReCaptchaProvider>
	// )
	return (
		isMobileVerified
			? isRedirectedFromMPS ? <MPSDemoModal /> : (
				isTechTalentEvent
					? <TechTalentProfileSteps isNewProfile={isNewProfile} token={token} />
					: <ProfileSteps isNewProfile={isNewProfile} token={token} />
			)
			: (
				<GoogleReCaptchaProvider
					language="es-AR"
					reCaptchaKey="6LcegMEfAAAAAOJZagpob5W_y7SBkbcI0Auhk3nu"
				>
					<VerifyMobile setIsMobileVerified={setIsMobileVerified} countryCode={props?.locale === 'my' ? '+60' : '+65'} isTechTalent={isTechTalentEvent} />
				</GoogleReCaptchaProvider>
			)
	)
}

export async function getServerSideProps ({ locale }) {
	return {
		props: {
			...(await serverSideTranslations(locale, ['common'])),
			locale: locale
		}
	}
}

export default Register
